import { gql } from '@apollo/client'

const UPDATE_LOCATION_TYPE_IMAGE_DETAILS_MUTATION = gql`
  mutation updateLocationTypeImageDetails(
    $id: ID!
    $data: LocationTypeImageDetailsInput!
  ) {
    updateLocationTypeImageDetails(id: $id, data: $data) {
      id
      imageUrl
      iconUrl
      updatedAt

      updatedBy {
        id
        name
      }
    }
  }
`

export default UPDATE_LOCATION_TYPE_IMAGE_DETAILS_MUTATION
